import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope, faUser, faIdBadge } from '@fortawesome/free-regular-svg-icons'
import { formatCurrency } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import Select from "react-select";

function Balances({selectedUser}) {
      const [crypto, setCrypto] = useState([]);
      const [fiat, setFiat] = useState([]);
      const [stock, setStock] = useState([]);
      const [wallet, setWallet] = useState([]);
      const [walletlist, setWalletlist] = useState([]);
      const [usdbal, setUsdbal] = useState(0);
      const [amount, setAmount] = useState();
      const [assethistory, setAssethistory] = useState([]);
      const [asset, setAsset] = useState();
      const [symbol, setSymbol] = useState();
      const [balance, setBalance] = useState(0);
      const [fund, setFund] = useState();
      const [loading, setLoading] = useState(false);
      const [disable, setDisable] = useState(true);
      useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchwallet1: true, user : selectedUser.email  })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            setWallet(data.wallet);
          }
        })
        .catch(err => {
          
        })
      }, [selectedUser]);
      useEffect(() => {
          fetch(`/coin_list.txt`)
          .then((res) => res.json())
          .then((data) => {
          var coinList = data.data;
          const updatedData = coinList.map((coin, index) => ({
              id: index + 1,
              logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
              name: coin.name,
              type: 'crypto',
              symbol: coin.symbol,
              price: Number(coin.quote.USD.price.toFixed(2)),
              label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
              value: coin.name,
              amount: 0,
          }));
          setCrypto(updatedData);
          })
          .catch((err) => console.error("Error loading coin list:", err));
      }, []);
      useEffect(() => {
        fetch(`/stock_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
            id: index + 1,
            logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
            name: stock.name,
            type: 'stock',
            symbol: stock.symbol,
            price: Number(stock.price.toFixed(2)),
            label: <><img src={`https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`} alt={stock.symbol} width="20" /> {stock.symbol}</>,
            value: stock.name,
            amount: 0,
        }));
        setStock(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
      }, []);
      useEffect(() => {   
          fetch(`/fiat_list.txt`)
          .then((res) => res.json())
          .then((data) => {
            const wantedCurrencies = {
              AUD: 'Australian Dollar',
              CAD: 'Canadian Dollar',
              CHF: 'Swiss Franc',
              CNY: 'Chinese Yuan',
              EUR: 'Euro',
              GBP: 'British Pound',
              INR: 'Indian Rupee',
              JPY: 'Japanese Yen',
              RUB: 'Russian Ruble',
              USD: 'US Dollar',
              ZAR: 'South African Rand'
            };
            const fiatList = Object.entries(data)
              .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
              .map(([code, value], index) => ({
                id: index + 1,
                symbol: code,
                name: wantedCurrencies[code],
                price: Number(value),
                type: 'fiat',
                label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {code}</>,
                value: wantedCurrencies[code],
                logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
                amount: 0,
              }));
            
            setFiat(fiatList);
          })
          .catch((err) => console.error("Error loading coin list:", err));
      }, []);
    useEffect(() => {
        if (!crypto.length && !fiat.length && !stock.length) return;
        const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
        }, {});
        let total = 0;
        const applyWalletBalance = (list) =>
        list.map(item => {
            const key = item.name?.trim().toLowerCase();
            const matchedBalance = walletMap[key];
            const amount = matchedBalance || 0;
            const value = amount * item.price;
            total += value;
            return {
            ...item,
            amount: matchedBalance || 0
            };
        });
        const merged = [
        ...applyWalletBalance(crypto),
        ...applyWalletBalance(fiat),
        ...applyWalletBalance(stock)
        ];
        const sorted = merged.sort((a, b) => {
        if (b.amount > 0 && a.amount === 0) return 1;
        if (a.amount > 0 && b.amount === 0) return -1;
        return a.name.localeCompare(b.name);
        });
        setAssethistory(sorted);
        setUsdbal(total);

        const enrichedWallet = wallet.map(walletItem => {
            const key = walletItem.coinName?.trim().toLowerCase();
            const matchedAsset = merged.find(asset => asset.name?.trim().toLowerCase() === key);
            return {
                ...walletItem,
                symbol: matchedAsset?.symbol || walletItem.coin,
                name: matchedAsset?.name || walletItem.coinName,
                price: matchedAsset?.price || 0,
                logo: matchedAsset?.logo,
            };
        });
        setWalletlist(enrichedWallet);
    }, [crypto, fiat, stock, wallet]);

    const darkThemeStyles1 = {
      control: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        border: "none",
        color: "#fff",
        fontWeight: '600',
      }),
      menu: (styles) => ({
        ...styles,
        backgroundColor: "rgb(30, 33, 36)",
        fontWeight: '600',
      }),
      option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
        color: "#fff",
        fontWeight: '600',
      }),
      singleValue: (styles) => ({
        ...styles,
        color: "#fff",
        fontWeight: '600',
      }),
    };

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const fundoptions = [
    { value: "add", label: "Add to balance" },
    { value: "remove", label: "Remove from balance" },
  ];
  useEffect(() => {
    if(amount && fund && asset){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [amount, fund, asset]);

    const AddBalance = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ funduser: true, email: selectedUser?.email, asset:asset, fund:fund, amount:amount, symbol :symbol })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err);
          setLoading(false);
        })
    }
    return (
        <div>
            <p className="fw-bold mb-0">User</p>
            <p className="mb-0" style={{fontSize:'14px'}}>Edit profile photo and other account info.</p>
            <div className="mt-3 rounded-4 p-1" style={{backgroundColor:'rgba(255,255,255,0.03)',cursor:'pointer'}}>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.fullname}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover lh-1 rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faIdBadge} style={{fontSize: '16px'}} className="me-1" /> @{selectedUser.username}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faEnvelope} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.email}</p>
            </div>
            <div className="d-flex align-items-center justify-content-between px-3 py-2 linkHover rounded-3">
                <p className="mb-0 fw-semibold"><FontAwesomeIcon icon={faPhone} style={{fontSize: '16px'}} className="me-1" /> {selectedUser.phone}</p>
            </div>
            </div>
            <p className="mt-5 mb-0" style={{fontSize:'14px'}}>Balances</p>
            <p className="mt-0 mb-3" style={{fontSize:'14px'}}>Please note that the total balance does not account for real estate, subscriptions, referral, signal or other balances.</p>
            <div className="rounded-4 p-4 mb-2" style={{backgroundColor: '#1a1c1f'}}>
                <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Balance</p>
                <h5 className="mb-0 fw-bold text-white">${formatCurrency(usdbal)}</h5>
            </div>
            <div className="rounded-4 p-4 mb-2" style={{backgroundColor: '#1a1c1f'}}>
                <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Deposits</p>
                <h5 className="mb-0 fw-bold text-white">${formatCurrency(selectedUser.total_deposit)}</h5>
            </div>
            <div className="rounded-4 p-4 mb-2" style={{backgroundColor: '#1a1c1f'}}>
                <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Withdrawals</p>
                <h5 className="mb-0 fw-bold text-white">${formatCurrency(selectedUser.total_withdraw)}</h5>
            </div>
            <div className="rounded-4 p-4 mb-2" style={{backgroundColor: '#1a1c1f'}}>
                <p className="mb-0 fw-semibold text-secondary" style={{fontSize:'14px'}}>Total Profit</p>
                <h5 className="mb-0 fw-bold text-white">${formatCurrency(selectedUser.profit)}</h5>
            </div>
            <p className="mt-4 mb-0 fw-semibold" style={{fontSize:'14px'}}>Edit Balance</p>
            <p className="mt-0 mb-3" style={{fontSize:'14px'}}>Manage the user's balances and modify account.</p>     
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
              <input 
                type="text" 
                placeholder="0.001" 
                className="inputNone"
                value={amount}
                onChange={(e) => {setAmount(e.target.value);}}
              />
              <Select 
                options={assethistory}
                placeholder="Assets" 
                value={assethistory.find(opt => opt.value === asset)}
                onChange={opt => (setAsset(opt.value), setSymbol(opt.symbol), setBalance(opt.amount))}
                isSearchable
                styles={darkThemeStyles1}
                className="w-full"
              />
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p style={{fontSize:'14px'}}>Current {symbol} balance:</p>
              <p style={{fontSize:'14px'}}>{balance} {symbol}</p>
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Action:</label>
            <Select 
              options={fundoptions} 
              value={fundoptions.find((opt) => opt.value === fund)}
              onChange={(e) => {setFund(e.value)}}
              styles={darkThemeStyles}
              className="w-full"
            />
            <div className={`myBtn bg-prime w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddBalance : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
            <p className="mt-4 mb-0 fw-semibold" style={{fontSize:'14px'}}>Assets</p>
            <p className="mt-0 mb-3" style={{fontSize:'14px'}}>Available assets in user's trading accounts.</p>
            
            {walletlist.map((coin) => (
              <div key={coin.id || coin.symbol} className="d-flex align-items-center justify-content-between mb-2 rounded-2 px-3 py-2" style={{backgroundColor:"#ffffff06"}}>
                <div className="d-flex align-items-center">
                  <img src={coin.logo} alt={coin.symbol} width="20" />
                  <p className="ms-2 mb-0 fw-semibold" style={{fontSize:'14px'}}>{coin.name}</p>
                </div>
                <div className="d-flex align-items-center">
                  <p className="ms-2 mb-0 fw-semibold" style={{fontSize:'14px'}}>{coin.balance} {coin.symbol}</p>
                  <p className="ms-2 mb-0 text-secondary ms-2" style={{fontSize:'14px'}}>${formatCurrency(coin.balance * coin.price)}</p>
                </div>
              </div>
            ))}
        </div>
    )
}

export default Balances